import { normalizeEntityStatus } from "./entityStatus";

const transformClientResponse = (data) => {
  const sectionMap = {};
  const sectionPermissionsById = {};
  data.sections.forEach((sec) => {
    sectionMap[sec.sectionId] = sec.data;
    sectionPermissionsById[sec.sectionId] = sec.permissions || {};
  });

  // ------------------ CLIENT DETAILS ------------------
  const additionalInfoRaw = Array.isArray(sectionMap["AdditionalInformation"]) ? sectionMap["AdditionalInformation"] : [];
  const additionalInfo = additionalInfoRaw.map((info, idx) => ({
    id: info.additionalInformationId || idx + 1,
    updatedOn: info.updated_at || "",
    comment: info.comment || "",
    userId: info.userId?.toString() || "",
  }))

  const correspondenceRaw = Array.isArray(sectionMap["Correspondence"]) ? sectionMap["Correspondence"] : [];
  const correspondanceTo = correspondenceRaw.map((corr, idx) => ({
    id: corr.correspondenceId || idx + 1,
    correspondenceType: corr.correspondenceType || "",
    name: corr.name || "",
    email: corr.emailId || "",
    phone: corr.phoneNumber || "",
    familyNo: corr.familyNo || "",
    notes: corr.notes || "",
  }));

  const clientDetailRaw = sectionMap["ClientDetail"] || {};

  const clientDetails = {
    clientName: data.clientName || "",
    sourceOfClientName: data.sourceOfClientName || "",
    clientNumber: data.clientNumber || "",
    usptoCustomerNumber: data.usptoCustomerNumber || "21971",
    address: data.address || "",
    phone: data.phoneNumber || "",
    entityStatus: normalizeEntityStatus(data.entityStatus),
    entityStatusSource: data.sourceOfEntityStatus || "",
    corporationCountry: data.incorporationCountry || "",
    corporationState: data.incorporationState || "",
    executedPoa: data.poaExecuted || "",
    executedPoaLocation: data.poaLocation || "",
    assignmentCountry: data.assignmentCountry || "",
    assignmentState: data.assignmentState || "",
    signatory: data.signatory || "",
    signatoryTitle: data.signatoryTitle || "",
    lastUpdatedOn: data.lastUpdatedAt || data.updatedAt || clientDetailRaw.lastUpdatedAt || clientDetailRaw.updatedAt || "",
    correspondanceTo: correspondanceTo,
    documentUrls: data.documentUrls || [],
  };

  // ------------------ CLIENT PREFERENCES ------------------
  const prefRaw = sectionMap["ClientPreference"] || [];
  const prefList = Array.isArray(prefRaw) ? prefRaw : prefRaw ? [prefRaw] : [];
  const clientPreferences = prefList.map((pref, index) => ({
    id: pref.clientPreferenceId || index + 1,
    ptaReview: pref.ptaReview || "",
    receivedBy: pref.receivedBy || "",
    preferenceDate: pref.preferenceDate || "",
    notes: pref.notes || "",
  }));

  // ------------------ BILLING INVOICING ------------------
  // IDS Billing Arrangement: 1-to-1 (BillingInvoicing.idsBillingArrangement)
  // Instructions: 1-to-N (BillingInstruction)
  // Invoicing Recipients: 1-to-N (BillingInvoicingRecipient)
  const billingRaw = sectionMap["BillingInvoicing"] || {};
  const billingInstructionsRaw = Array.isArray(sectionMap["BillingInstruction"]) ? sectionMap["BillingInstruction"] : [];
  const billingRecipientsRaw = Array.isArray(sectionMap["BillingInvoicingRecipient"]) ? sectionMap["BillingInvoicingRecipient"] : [];

  const billing = {
    instructions: billingInstructionsRaw.map((item, index) => ({
      id: item.billingInstructionId || index + 1,
      instructions: item.instruction || "",
      advancedInvocingRequired: item.advanceInvoiceRequired || "",
      notes: item.notes || "",
    })),
    invoicing: billingRecipientsRaw.map((item, index) => ({
      id: item.billingInvoicingRecipientId || index + 1,
      recpientName: item.name || "",
      email: item.emailId || "",
      phone: item.phoneNumber || "",
      notes: item.notes || "",
    })),
    idsBillingArrangements: [{ id: 1, billingArrangement: billingRaw.idsBillingArrangement || "", notes: billingRaw.notes || "" }],
  };

  // ------------------ ADDITIONAL INFO ------------------

  // ------------------ PARALEGAL INSTRUCTIONS ------------------
  const paralegalInstructionsRaw = sectionMap["ParalegalInstruction"] || [];

  const paralegalInstructions = paralegalInstructionsRaw.map((item, index) => ({
    id: item.paralegalInstructionId || index + 1,
    action: item.action || "",
    wsgrResponsible: item.wsgrResponsible || "",
    matters: item.matters || "",
    notes: item.notes || "",
  }));

  // ------------------ INVENTORS ------------------
  const inventorsRaw = sectionMap["Inventor"] || [];

  const inventors = inventorsRaw.map((item, index) => ({
    id: item.inventorId || index + 1,
    prefix: item.prefix || "",
    firstName: item.firstName || "",
    middleName: item.middleName || "",
    lastName: item.lastName || "",
    suffix: item.suffix || "",
    nationality: item.nationality || "",
    citizenship: item.citizenship || "",
    address1: item.address1 || "",
    address2: item.address2 || "",
    address3: item.address3 || "",
    address4: item.address4 || "",
    city: item.city || "",
    state: item.state || "",
    country: item.country || "",
    verifiedDate: item.verifiedDate || "",
    email: item.emailId || "",
    notes: item.notes || "",
  }));

  // ------------------ LICENSED FAMILIES ------------------
  const licensedFamiliesRaw = sectionMap["LicensedFamily"] || [];
  const licensedFamilies = licensedFamiliesRaw.map((item, index) => ({
    id: item.licensedFamilyId || index + 1,
    partyRelationship: item.partyRelationship || "",
    familyNo: item.familyNo || "",
    licensedTo: item.licensedTo || "",
    contactName: item.contactName || "",
    emailId: item.emailId || "",
    notes: item.notes || "",
  }));

  // ------------------ SHADOWING STATUS FAMILY ------------------
  const statusByFamilyRaw = sectionMap["ShadowingStatusFamily"] || [];
  const statusByFamily = statusByFamilyRaw.map((item, index) => ({
    id: item.shadowingStatusFamilyId || index + 1,
    wsgrHandles: item.wsgrHandles || "",
    familyNo: item.familyNo || "",
    prosecutingFirm: item.prosecutingFirm || "",
    notes: item.notes || "",
  }));

  // ------------------ PPS INSTRUCTIONS ------------------
  const ppsInstructionsRaw = sectionMap["PpsInstruction"] || [];
  const ppsInstructions = ppsInstructionsRaw.map((item, index) => ({
    id: item.ppsInstructionId || index + 1,
    action: item.action || "",
    wsgrResponsible: item.wsgrResponsible || "",
    matters: item.matters || "",
    notes: item.notes || "",
  }));

  // ------------------ RECURRING ACTIONS ------------------
  const recurringActionsRaw = sectionMap["RecurringAction"] || [];
  const recurringActions = recurringActionsRaw.map((item, index) => ({
    id: item.recurringActionId || index + 1,
    action: item.action || "",
    frequency: item.frequency || "",
    nextActionDate: item.nextActionDate || "",
    notes: item.notes || "",
  }));

  // ------------------ FOREIGN ASSOCIATES ------------------
  const foreignAssociatesRaw = sectionMap["ForeignAssociate"] || [];
  const foreignAssociates = foreignAssociatesRaw.map((item, index) => ({
    id: item.foreignAssociateId || index + 1,
    country: item.country || "",
    associateName: item.associateName || "",
    associateEmails: item.emailId
      ? String(item.emailId)
          .split(",")
          .map((e) => e.trim())
          .filter(Boolean)
      : [],
  }));

  // ------------------ ATTORNEY PREFERENCES ------------------
  const attorneyPreferencesRaw = sectionMap["AgentAttorneyPreference"] || [];
  const attorneyPreferences = attorneyPreferencesRaw.map((item, index) => ({
    id: item.agentAttorneyPreferenceId || index + 1,
    agentAttorneyName: item.agentAttorneyName || "",
    familyNo: item.familyNo || "",
    notes: item.notes || "",
  }));

  // ------------------ ANNUITIES ------------------
  const annuitiesRaw = sectionMap["Annuity"] || [];
  const annuties = annuitiesRaw.map((item, index) => ({
    id: item.annuityId || index + 1,
    familyNo: item.familyNo || "",
    paidBy: item.paidBy || "",
    notes: item.notes || "",
  }));

  // ------------------ ASSIGNMENTS ------------------
  const assignments = Array.isArray(data.assignments) ? data.assignments : [];
  const assignmentsByRole = {};
  assignments.forEach((asgn) => {
    if (!assignmentsByRole[asgn.assignmentRole]) assignmentsByRole[asgn.assignmentRole] = [];
    assignmentsByRole[asgn.assignmentRole].push({
      personid: asgn.user?.id ? Number(asgn.user.id) : null,
      first_name: asgn.user?.displayName ? asgn.user.displayName.split(" ")[0] : "User",
      last_name: asgn.user?.displayName ? asgn.user.displayName.split(" ").slice(1).join(" ") : "",
      email: asgn.user?.email || "",
      isPrimary: asgn.isPrimary || false,
      isBackup: asgn.isBackup || false,
      assignedAt: asgn.assignedAt,
    });
  });

  // ------------------ DEFAULT EMPTY SECTIONS ------------------
  return {
    clientId: data.id,
    status: data.status,
    isPrivate: data.isPrivate,
    isFavorite: data.isFavorite,
    assignments: data.assignments,
    clientDetails,
    licensedFamilies,
    statusByFamily,
    paralegalInstructions,
    ppsInstructions,
    recurringActions,
    foreignAssociates,
    inventors,
    billing,
    clientPreferences,
    attorneyPreferences,
    annuties,
    additionalInfo,
    assignmentsByRole,
    sectionPermissionsById,
  };
};

export default transformClientResponse;
